// Date formatters
export const formatDate = (date, format = 'short') => {
  if (!date) return '';
  
  const dateObj = new Date(date);
  const options = {
    short: { day: '2-digit', month: '2-digit', year: 'numeric' },
    long: { day: '2-digit', month: 'long', year: 'numeric' },
    datetime: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    },
    time: { hour: '2-digit', minute: '2-digit' },
  };

  const opt = options[format] || options.short;
  if (format === 'datetime') {
    return dateObj.toLocaleString('es-ES', opt);
  }
  if (format === 'time') {
    return dateObj.toLocaleTimeString('es-ES', opt);
  }
  return dateObj.toLocaleDateString('es-ES', opt);
};

// Currency formatters
export const formatCurrency = (amount, currency = 'USD') => {
  if (amount === null || amount === undefined) return '';
  
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

// Number formatters
export const formatNumber = (number, decimals = 0) => {
  if (number === null || number === undefined) return '';
  
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number);
};

// File size formatters
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Text formatters
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  
  return text.substring(0, maxLength) + '...';
};

export const capitalizeFirst = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

// Status formatters
export const formatStatus = (status) => {
  const statusMap = {
    active: 'Activo',
    inactive: 'Inactivo',
    suspended: 'Suspendido',
    pending: 'Pendiente',
    expired: 'Expirado',
    cancelled: 'Cancelado',
    trial: 'Trial',
    basic: 'Básica',
    premium: 'Premium',
    enterprise: 'Empresarial',
  };
  
  return statusMap[status] || status;
};

// License key formatters
export const formatLicenseKey = (key) => {
  if (!key) return '';
  
  // Format as XXXX-XXXX-XXXX-XXXX
  return key.replace(/(.{4})/g, '$1-').replace(/-$/, '');
};

// Phone number formatters
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format as +XX XXX XXX XXXX
  if (cleaned.length >= 10) {
    return `+${cleaned.slice(0, -10)} ${cleaned.slice(-10, -7)} ${cleaned.slice(-7, -4)} ${cleaned.slice(-4)}`;
  }
  
  return phone;
};